<template>
  <img src="../assets/tm.png" alt="" class="seal" ref="seal"
    :style="{ 'left': myLeft + 'px', 'top': myTop + 'px', 'width': maxWidth * 0.21 + 'px', 'height': maxWidth * 0.21 + 'px', 'background-image': `url(${src})` }"
    @mousedown.stop.prevent="mousedown($event)" @mouseup="mouseup($event)">
</template>

<script>
export default {
  props: {
    left: {
      type: Number,
      required: true
    },
    top: {
      type: Number,
      required: true
    },
    src: {
      type: String,
      required: true
    },
    maxWidth: {
      type: Number,
      required: true,
      default: 0
    },
    maxHeight: {
      type: Number,
      required: true,
      default: 0
    },
    index: {
      type: Number,
      required: true
    },
    type: {}
  },
  data() {
    return {
      x: null,
      y: null,
      myLeft: this.left,
      myTop: this.top
    }
  },
  mounted() {
    this.sendCoordinate();
  },
  methods: {
    mousedown(e) {
      let that = this;
      let event = e || window.event;

      let startx = event.clientX;
      let starty = event.clientY;
      let sbBkx = startx - event.target.offsetLeft;
      let sbBky = starty - event.target.offsetTop;
      let offsetWdith = event.target.offsetWidth;
      let offsetHeight = event.target.offsetHeight;

      document.onmousemove = (ev) => {

        event = ev || window.event;
        let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;

        let endx = event.clientX - sbBkx;
        let endy = event.clientY - sbBky;
        that.myLeft = endx;
        that.myTop = endy;
        if (ev.clientX - sbBkx < 0) {
          that.myLeft = 0;
        }
        if (ev.clientY - sbBky < 0) {
          that.myTop = 0;
        }
        if (ev.clientX - sbBkx + offsetWdith > this.maxWidth) {
          that.myLeft = this.maxWidth - offsetWdith;
        }
        if (ev.clientY - sbBky + offsetHeight > this.maxHeight) {
          that.myTop = this.maxHeight - offsetHeight;
        }
      }
    },
    mouseup() {
      document.onmouseup = () => {
        document.onmousemove = null;
        this.sendCoordinate();
        // console.log(this.x, this.y);
      }
    },
    // 计算坐标发送到父组件
    sendCoordinate() {
      this.x = (this.myLeft / this.maxWidth).toFixed(2);
      this.y = ((this.maxHeight - (this.myTop + this.$refs.seal.offsetHeight)) / this.maxHeight).toFixed(2);
      this.$emit('sendCoordinate', {
        x: this.x,
        y: this.y,
        index: this.index
      })
    }
  },
  beforeDestroy() {
    this.mouseup = function () { };
    this.sendCoordinate = function () { };
  }
}
</script>
<style lang="less" scoped>
.seal {
  width: 100px;
  height: 100px;
  position: fixed;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: block;
  background-size: 100%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
</style>